module.exports = __webpack_public_path__ + "img/download_register.b4f997bb.png";